<template>
  <v-container class="d-flex flex-column ga-3">
    <v-row>
      <v-col>
        <UsageExample v-model="tab" :code="code" :tabs="tabs">
          <v-card elevation="4">
            <v-card-title>Helix Trackers</v-card-title>
            <HxTrackers v-model="currentStep" :items="items" />
            <v-btn color="primary" class="ma-2" @click="showHxModalButton = true">HxTrackers</v-btn>
            <HxModal
              v-model="showHxModalButton"
              title="HxTrackers"
              :primary-action="{
                label: 'Next',
                variant: 'primary'
              }"
              :secondary-action1="{
                label: 'Cancel',
                variant: 'secondary'
              }"
              @primary-click="currentStep++"
              @secondary1-click="showHxModalButton = false"
            >
              <template #content>
                <HxTrackers v-model="currentStep" :items="items">
                  <template v-for="(item, index) in items" :key="index" #[`item.${index+1}`]>
                    {{ escapeCodeStringSlot(index + 1) }}
                  </template>
                </HxTrackers>
              </template>
            </HxModal>
          </v-card>
        </UsageExample>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import UsageExample from '@/components/helix/utils/UsageExample';

export default {
  name: 'HelixTrackers',
  components: { UsageExample },
  setup() {
    // escape `item.${index+1}`
    const specialSymbol = {
      backtick: '`',
      dollar: '$',
      curlyBracketOpen: '{',
      curlyBracketClose: '}'
    };
    const templateLiteral = specialSymbol.backtick;
    let codeString = 'item.';
    codeString += specialSymbol.dollar;
    codeString += specialSymbol.curlyBracketOpen;
    codeString += 'index+1';
    codeString += specialSymbol.curlyBracketClose;

    const code = `
<HxTrackers
  v-model="currentStep"
  :items="[
        { title: 'Step 1', subtitle: 'Subtitle 1', state: 'complete' },
        { title: 'Step 2', subtitle: 'Subtitle 2', state: 'error' },
        { title: 'Step 3', subtitle: 'Subtitle 3', state: 'skip' },
        { title: 'Step 4', subtitle: 'Subtitle 4' },
        { title: 'Step 5', subtitle: 'Subtitle 5' },
        { title: 'Step 6', subtitle: 'Subtitle 6', state: 'current' },
        { title: 'Step 7', subtitle: 'Subtitle 7', state: 'past' }
      ]"
/>
<v-btn color="primary" class="ma-2" @click="showHxModalButton = true">HxTrackers</v-btn>
<HxModal
  v-model="showHxModalButton"
  title="HxTrackers"
  :primary-action="{
    label: 'Next',
    variant: 'primary'
  }"
  :secondary-action1="{
    label: 'Cancel',
    variant: 'secondary'
  }"
  @primary-click="currentStep++"
  @secondary1-click="showHxModalButton = false"
>
  <template #content>
    <HxTrackers v-model="currentStep" :items="items">
      <template v-for="(item, index) in items" :key="index" #[${templateLiteral}${codeString}${templateLiteral}]>
        Insert your content here
      </template>
    </HxTrackers>
  </template>
</HxModal>
    `;
    return { code };
  },
  data() {
    return {
      tab: 'Trackers Usage',
      tabs: ['Trackers Usage'],
      currentStep: 4,
      items: [
        { title: 'Step 1', subtitle: 'Subtitle 1', state: 'complete' },
        { title: 'Step 2', subtitle: 'Subtitle 2', state: 'error' },
        { title: 'Step 3', subtitle: 'Subtitle 3', state: 'skip' },
        { title: 'Step 4', subtitle: 'Subtitle 4' },
        { title: 'Step 5', subtitle: 'Subtitle 5' },
        { title: 'Step 6', subtitle: 'Subtitle 6', state: 'current' },
        { title: 'Step 7', subtitle: 'Subtitle 7', state: 'past' }
      ],
      showHxModalButton: false,
      slotCode: ''
    };
  },
  computed: {
    escapeCodeStringSlot() {
      // escape <template #[`item.1`]></template>
      return (index) =>
        `<template #[\`item.${index}\`]>
          Insert your content here
          </template>`;
    }
  }
};
</script>
